<template>
  <div id="app">
    <!-- Navbar start -->
    <NavBar></NavBar>
    <!-- Navbar End -->

    <!-- Modal Search Start -->
    <NavSearch></NavSearch>
    <!-- Modal Search End -->
  
    <RouterView/>

    <!-- Footer Start -->
    <FooterView></FooterView>
    <!-- Footer End -->
  </div>
</template>
<script>
import { RouterView } from 'vue-router';
import Home from './views/Home.vue';
import NavBar from './components/NavBar.vue'
import NavSearch from './components/NavSearch.vue'
import FooterView from './components/FooterView.vue'

export default {
  data() {
    return {
      categories: []
    }
  },
  components : {
    Home,
    NavBar,
    NavSearch,
    FooterView
  },
  methods: {
    
  },
  mounted() {
 
  }
}
</script>